/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import "./App.scss"
import { LoadingContext } from "./context/LoadingContext"
import PagesLayout from "./core/PagesLayout"
import { authenticationService, setupAxiosClient } from "./core/utils"
import React, { Component } from "react"
import { Toaster } from "react-hot-toast"
import { BrowserRouter, Route, Switch } from "react-router-dom"

setupAxiosClient(window.location.origin)

const toastOptions = {
  position: "bottom-right",
  success: {
    style: {
      background: "#07bc0c",
      color: "#fff"
    },
    iconTheme: {
      primary: "#fff",
      secondary: "#07bc0c"
    },
    duration: 4000
  },
  error: {
    style: {
      background: "#e74c3c",
      color: "#fff"
    },
    iconTheme: {
      primary: "#fff",
      secondary: "#e74c3c"
    },
    duration: 4000
  },
  loading: {
    style: {}
  }
}

class App extends Component {
  state = {
    loading: 0
  }

  incrementLoading = () => {
    const { loading } = this.state
    this.setState({ loading: loading + 1 })
  }

  decrementLoading = () => {
    const { loading } = this.state
    this.setState({ loading: loading - 1 })
  }

  componentDidMount() {
    authenticationService.addListener("logged", this.handleLoggedEvent)

    if (
      process.env.REACT_APP_ENV === "local" ||
      process.env.REACT_APP_ENV === "uat" ||
      process.env.REACT_APP_ENV === "sit"
    ) {
      console.log(`${process.env.REACT_APP_NAME} ${process.env.REACT_APP_VERSION}`)
    }
  }

  componentWillUnmount() {
    authenticationService.removeListener("logged", this.handleLoggedEvent)
  }

  handleLoggedEvent = (logged) => {
    this.setState({ logged })
  }

  render() {
    let i = 1
    const { loading } = this.state
    const loadingProps = {
      loading: loading,
      incrementLoading: this.incrementLoading,
      decrementLoading: this.decrementLoading
    }
    return (
      <BrowserRouter>
        <LoadingContext.Provider value={{ loading: loading }}>
          <Switch>
            <Route path="/" render={(routeProps) => <PagesLayout  {...routeProps} {...loadingProps} />} key={i++} />
          </Switch>
          <Toaster toastOptions={toastOptions} />
        </LoadingContext.Provider>
      </BrowserRouter>
    )
  }
}

export default App
